import { RootState } from '../rootReducer';

export const selectResourcePrice = (state: RootState) => state.resourcePrice.resourcePrice.price;
export const selectResourcePROPrice = (state: RootState) => state.resourcePrice.resourcePrice.pro_price;
